import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * News Letter Routes and Pages
 */
const ListNewsLetterPage = React.lazy(() => import("./ListNewsLetterPage"));
const AddNewsLetterPage = React.lazy(() => import("./AddNewsLetterPage.js"));
const EditNewsLetterPage = React.lazy(() => import("./EditNewsLetterPage"));

const NewsLetterRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListNewsLetterPage />} />
      <Route exact path="/add" element={<AddNewsLetterPage />} />
      <Route exact path="/edit/:id" element={<EditNewsLetterPage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default NewsLetterRoutes;
